export const sqlErrors = {
  SQL_CLIENT_FAILURE: {
    status: 401,
    code: 'SQL_CLIENT_FAILURE',
    title: 'SQL Client Error',
    subtitle: 'SQL CLIENT ERROR',
    description: 'There was an issue authenticating the SQL client. Please check the connection or try logging in again. If the issue persists, contact support for assistance.',
    showResponseBody: true,
    component: 'DefaultErrorPage'
  },
  SQL_OPERATION_NOT_SUPPORTED: {
    status: 403,
    code: 'SQL_OPERATION_NOT_SUPPORTED',
    title: 'SQL Operation Not Supported',
    subtitle: 'SQL ERROR',
    description: "The SQL operation you're trying to perform is not supported. Please contact support or try a different operation.",
    component: 'DefaultErrorPage'
  },
  SQL_MUTATION_REJECTED: {
    status: 403,
    code: 'SQL_MUTATION_REJECTED',
    title: 'SQL Mutation Rejected',
    subtitle: 'READ-ONLY ACTION',
    description: 'The Select action only runs read-only SQL. The query was rejected before reaching the database because it contains a statement or construct that could modify data. Use a single SELECT, WITH, SHOW, or EXPLAIN statement, or use the Query action for writes.',
    showResponseBody: true,
    component: 'DefaultErrorPage'
  },
  SQL_QUERY_FAILURE: {
    status: 500,
    code: 'SQL_QUERY_FAILURE',
    title: 'SQL Query Execution Failed',
    subtitle: 'DATABASE ERROR',
    description: 'The system encountered an issue while executing the SQL query. This may be due to incorrect syntax, missing data, or a connection issue with the database. Please review the query and ensure that all parameters are correct.',
    component: 'DefaultErrorPage'
  }
};
